import { isWarnable } from '@tableau/catalog-ui-temp';

import { openDataQualityDialogCatalog } from '../sagas/labels/SetDataQualitySaga';
import { openSenstiveLabelDialogCatalog } from '../sagas/labels/SetSensitiveLabelSaga';


export type RenderDataQualityDialogParams = {
  readonly content: {
    readonly contentId: string;
    readonly contentName: string;
    readonly contentType: string;
    readonly contentIcon?: JSX.Element;
    readonly contentIconTitle?: string;
  };
  readonly dismiss: () => void;
}

export function renderDataQualityDialog(params: RenderDataQualityDialogParams): Promise<unknown> {
  const { contentId, contentName, contentType, contentIcon, contentIconTitle } = params.content;
  if (!isWarnable(contentType)) {
    return null;
  }

  return openDataQualityDialogCatalog({
    contentItem: {
      contentName,
      contentId,
      contentType,
      contentIcon,
      contentIconTitle,
    },
    onSubmit: params.dismiss,
  });
}

export function renderSensitiveLabelsDialog(params: RenderDataQualityDialogParams): Promise<unknown> {
  const { contentId, contentName, contentType, contentIcon, contentIconTitle } = params.content;
  if (!isWarnable(contentType)) {
    return null;
  }

  return openSenstiveLabelDialogCatalog({
    contentItem: {
      contentName,
      contentId,
      contentType,
      contentIcon,
      contentIconTitle,
    },
    onSubmit: params.dismiss,
  });
}
